import isMobile from "@/utils/is-mobile";

(async () => {
  if (isMobile()) {
    await import("./mobile");
  } else {
    await import("./desktop");
  }
})();
